import "./main.css"

import * as React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./app/redux/config/store"
import { RouterProvider } from "react-router-dom"
import router from "./app/routes/router"
import { ModalProvider } from "./app/providers/ModalProvider"

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <ModalProvider>
        <RouterProvider router={router} />
      </ModalProvider>
    </Provider>
  </React.StrictMode>,
)
